import React from "react";
import Overview from "../../../components/pages/commercial/overview/Overview";
import RoleList from "../../../components/pages/commercial/SiteManagement/Role/RoleList";
import RoleForm from "../../../components/pages/commercial/SiteManagement/Role/RoleForm";
import SiteList from "../../../components/pages/commercial/SiteManagement/Site/SiteList";
import SiteForm from "../../../components/pages/commercial/SiteManagement/Site/SiteForm";
import WingList from "../../../components/pages/commercial/SiteManagement/Wing/WingList";
import WingForm from "../../../components/pages/commercial/SiteManagement/Wing/WingForm";
import FloorList from "../../../components/pages/commercial/SiteManagement/Floor/FloorList";
import FloorForm from "../../../components/pages/commercial/SiteManagement/Floor/FloorForm";
import UnitList from "../../../components/pages/commercial/SiteManagement/Unit/UnitList";
import UnitForm from "../../../components/pages/commercial/SiteManagement/Unit/UnitForm";
import SiteHierarchyBuilder from "../../../components/pages/commercial/SiteManagement/SiteHierarchyBuilder";
import SiteSetupWizard from "../../../components/pages/commercial/SiteManagement/SiteSetupWizard";
import MenuList from "../../../components/pages/commercial/SiteManagement/Menu/MenuList";
import MenuForm from "../../../components/pages/commercial/SiteManagement/Menu/MenuForm";
import ManageUsers from "../../../components/pages/commercial/UserManagment/ManageUsers";
import UserManagementForm from "../../../components/pages/commercial/UserManagment/UserManagementForm";
import TenantTenancyStepper from "../../../components/pages/commercial/UserManagment/TenancyStepper/TenantTenancyStepper";
import MyProfile from "../../../components/pages/Profile/MyProfile";
import VisitorRequest from "../../../components/pages/commercial/VisitorsManagment/InviteVisitor/VisitorRequest";
import InviteGuestForm from "../../../components/pages/commercial/VisitorsManagment/InviteVisitor/InviteGuestForm";
import WalkInVisitorList from "../../../components/pages/commercial/VisitorsManagment/walkinVisitor/WalkInVisitorList";
import GenerateQRCode from "../../../components/pages/commercial/VisitorsManagment/QRCode/GenerateQRCode";
import ParkingReport from "../../../components/pages/commercial/ParkingManagement/Reports/ParkingReport";
import VehicleTypeList from "../../../components/pages/commercial/ParkingManagement/VehicleType/VehicleTypeList";
import ParkingTypeList from "../../../components/pages/commercial/ParkingManagement/ParkingType/ParkingTypeList";
import ParkingSlotList from "../../../components/pages/commercial/ParkingManagement/ParkingSlot/ParkingSlotList";
import ParkingAssignUnitList from "../../../components/pages/commercial/ParkingManagement/ParkingAssignUnit/ParkingAssignUnitList";
import RentalDurationList from "../../../components/pages/commercial/ParkingManagement/RentalDuration/RentalDurationList";
import ParkingBookingList from "../../../components/pages/commercial/ParkingManagement/ParkingBooking/ParkingBookingList";

import VehicleTypeForm from "../../../components/pages/commercial/ParkingManagement/VehicleType/VehicleTypeForm";
import ParkingTypeForm from "../../../components/pages/commercial/ParkingManagement/ParkingType/ParkingTypeForm";
import ParkingSlotForm from "../../../components/pages/commercial/ParkingManagement/ParkingSlot/ParkingSlotForm";
import ParkingAssignUnitForm from "../../../components/pages/commercial/ParkingManagement/ParkingAssignUnit/ParkingAssignUnitForm";
import RentalDurationForm from "../../../components/pages/commercial/ParkingManagement/RentalDuration/RentalDurationForm";
import ParkingBookingForm from "../../../components/pages/commercial/ParkingManagement/ParkingBooking/ParkingBookingForm";
import VisitorReports from "../../../components/pages/commercial/VisitorsManagment/Reports/VisitorReports";
import AlertNotificationList from "../../../components/pages/commercial/AlertNotification/AlertNotificationList";
import AlertNotificationForm from "../../../components/pages/commercial/AlertNotification/AlertNotificationForm";
import MaintenanceModule from "../../../components/pages/commercial/Maintenance/MaintenanceModule";
import MaintenanceForm from "../../../components/pages/commercial/Maintenance/MaintenanceForm";
import VisitorPass from "../../../components/pages/commercial/VisitorsManagment/visitorpass/VisitorPass";
import AttendanceList from "../../../components/pages/commercial/UserManagment/Attendance/AttendanceList";
import AnnouncementList from "../../../components/pages/commercial/Announcement/AnnouncementList";
import AnnouncementForm from "../../../components/pages/commercial/Announcement/AnnouncementForm";
import ComplaintList from "../../../components/pages/commercial/ComplaintManagement/ComplaintList";
import ComplaintForm from "../../../components/pages/commercial/ComplaintManagement/ComplaintForm";

export const commercialRoutes = [
  // Commercial Module Routes - NOTE: Paths are now relative to the mount point (e.g., /zentcomm/)
  {
    path: "dashboard",
    element: <Overview />,
    breadcrumbs: ["Dashboard"],
  },
  {
    path: "my-profile",
    element: <MyProfile />,
    breadcrumbs: ["My Profile"],
  },
  {
    path: "user-management",
    element: <ManageUsers />,
    breadcrumbs: ["User Management"],
  },
  {
    path: "user-management/form",
    element: <UserManagementForm />,
    breadcrumbs: ["User Management", "User Form"],
  },
  {
    path: "user-management/manage-tenancy",
    element: <TenantTenancyStepper />,
    breadcrumbs: ["User Management", "Manage Tenancy"],
  },
  {
    path: "attendance",
    element: <AttendanceList />,
    breadcrumbs: ["Attendance"],
  },
  {
    path: "attendance-managemnet",
    element: <AttendanceList />,
    breadcrumbs: ["Attendance"],
  },
  {
    path: "announcement",
    element: <AnnouncementList />,
    breadcrumbs: ["Announcements"],
  },
  {
    path: "announcement/add",
    element: <AnnouncementForm />,
    breadcrumbs: ["Announcements", "Add"],
  },
  {
    path: "announcement/edit/:id",
    element: <AnnouncementForm />,
    breadcrumbs: ["Announcements", "Edit"],
  },
  {
    path: "visitor-managment/invited-visitor",
    element: <VisitorRequest />,
    breadcrumbs: ["Visitor Management", "Invited Visitor"],
  },
  {
    path: "visitor-managment/invited-visitor/add",
    element: <InviteGuestForm />,
    breadcrumbs: ["Visitor Management", "Invited Visitor", "Add"],
  },
  {
    path: "visitor-managment/visitor-pass",
    element: <VisitorPass />,
    breadcrumbs: ["Visitor Management", "Visitor Pass"],
  },
  {
    path: "visitor-managment/walk-in-visitor",
    element: <WalkInVisitorList />,
    breadcrumbs: ["Visitor Management", "Walk-In Visitor"],
  },
  {
    path: "visitor-managment/generateQR",
    element: <GenerateQRCode />,
    breadcrumbs: ["Visitor Management", "Generate QR Code"],
  },
  {
    path: "report/visitor",
    element: <VisitorReports />,
    breadcrumbs: ["Reports", "Visitor Report"],
  },
  {
    path: "report/parking-report",
    element: <ParkingReport />,
    breadcrumbs: ["Reports", "Parking Report"],
  },
  {
    path: "parking-management/vehicle-Type",
    element: <VehicleTypeList />,
    breadcrumbs: ["Parking Management", "Vehicle Type"],
  },
  {
    path: "parking-management/vehicle-Type/form",
    element: <VehicleTypeForm />,
    breadcrumbs: ["Parking Management", "Vehicle Type", "Form"],
  },
  {
    path: "parking-management/parking-Type",
    element: <ParkingTypeList />,
    breadcrumbs: ["Parking Management", "Parking Type"],
  },
  {
    path: "parking-management/parking-Type/form",
    element: <ParkingTypeForm />,
    breadcrumbs: ["Parking Management", "Parking Type", "Form"],
  },
  {
    path: "parking-management/parking-slot",
    element: <ParkingSlotList />,
    breadcrumbs: ["Parking Management", "Parking Slot"],
  },
  {
    path: "parking-management/parking-slot/form",
    element: <ParkingSlotForm />,
    breadcrumbs: ["Parking Management", "Parking Slot", "Form"],
  },
  {
    path: "parking-management/parking-assing-unit",
    element: <ParkingAssignUnitList />,
    breadcrumbs: ["Parking Management", "Parking Assign Unit"],
  },
  {
    path: "parking-management/parking-assing-unit/form",
    element: <ParkingAssignUnitForm />,
    breadcrumbs: ["Parking Management", "Parking Assign Unit", "Form"],
  },
  {
    path: "parking-management/rent-Type",
    element: <RentalDurationList />,
    breadcrumbs: ["Parking Management", "Duration of Rental"],
  },
  {
    path: "parking-management/rent-Type/form",
    element: <RentalDurationForm />,
    breadcrumbs: ["Parking Management", "Duration of Rental", "Form"],
  },
  {
    path: "parking-management/parking-Booking",
    element: <ParkingBookingList />,
    breadcrumbs: ["Parking Management", "Parking Reservation"],
  },
  {
    path: "parking-management/parking-Booking/form",
    element: <ParkingBookingForm />,
    breadcrumbs: ["Parking Management", "Parking Reservation", "Form"],
  },
  {
    path: "site-management/site",
    element: <SiteList />,
    breadcrumbs: ["Site Management", "Site List"],
  },
  {
    path: "site-management/site/form",
    element: <SiteForm />,
    breadcrumbs: ["Site Management", "Site", "Form"],
  },
  {
    path: "site-management/builder",
    element: <SiteHierarchyBuilder />,
    breadcrumbs: ["Site Management", "Site Preview"],
  },
  {
    path: "site-management/setup-wizard",
    element: <SiteSetupWizard />,
    breadcrumbs: ["Site Management", "Setup Wizard"],
  },
  {
    path: "site-management/role",
    element: <RoleList />,
    breadcrumbs: ["Site Management", "Role List"],
  },
  {
    path: "site-management/role/form",
    element: <RoleForm />,
    breadcrumbs: ["Site Management", "Role", "Form"],
  },
  {
    path: "site-management/wing",
    element: <WingList />,
    breadcrumbs: ["Site Management", "Wing"],
  },
  {
    path: "site-management/wing/form",
    element: <WingForm />,
    breadcrumbs: ["Site Management", "Wing", "Form"],
  },
  {
    path: "site-management/floor",
    element: <FloorList />,
    breadcrumbs: ["Site Management", "Floor"],
  },
  {
    path: "site-management/floor/form",
    element: <FloorForm />,
    breadcrumbs: ["Site Management", "Floor", "Form"],
  },
  {
    path: "site-management/unit",
    element: <UnitList />,
    breadcrumbs: ["Site Management", "Unit"],
  },
  {
    path: "site-management/unit/form",
    element: <UnitForm />,
    breadcrumbs: ["Site Management", "Unit", "Form"],
  },
  {
    path: "site-management/menu",
    element: <MenuList />,
    breadcrumbs: ["Site Management", "Menu"],
  },
  {
    path: "site-management/menu/form",
    element: <MenuForm />,
    breadcrumbs: ["Site Management", "Menu", "Form"],
  },
  {
    path: "alert-notification",
    element: <AlertNotificationList />,
    breadcrumbs: ["Alert Notification", "List"],
  },
  {
    path: "alert-notification/add",
    element: <AlertNotificationForm />,
    breadcrumbs: ["Alert Notification", "Add Notification"],
  },
  {
    path: "alert-notification/edit/:id",
    element: <AlertNotificationForm />,
    breadcrumbs: ["Alert Notification", "Edit Notification"],
  },
  {
    path: "maintenance",
    element: <MaintenanceModule />,
    breadcrumbs: ["Maintenance"],
  },
  {
    path: "maintenance/add",
    element: <MaintenanceForm />,
    breadcrumbs: ["Maintenance", "Add Maintenance"],
  },
  {
    path: "complaint-management",
    element: <ComplaintList />,
    breadcrumbs: ["Complaints"],
  },
  {
    path: "complaint-management/add",
    element: <ComplaintForm />,
    breadcrumbs: ["Complaints", "Raise Complaint"],
  },
  {
    path: "complaint-management/edit/:id",
    element: <ComplaintForm />,
    breadcrumbs: ["Complaints", "Modify Complaint"],
  }
];
